export function getDate (date) {
  if (!date) {
    return new Date()
  }

  if (date && date.constructor === Date) {
    return date
  }

  date = new Date(date)
  if (isNaN(date)) {
    date = new Date()
  }

  return date
}
